// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b4eb3d88","455":"0c0f62d5","977":"24667c7a"}[chunkId] + ".chunk.js";
};